import { toast } from "react-toastify";
import { privateAxios } from "../../../config/apiConfig";
import {
  REJECT_PRODUCT_FAILURE, REJECT_PRODUCT_REQUEST, DELETE_PRODUCT_FAILURE, DELETE_PRODUCT_REQUEST, APPROVED_PRODUCT_FAILURE, APPROVED_PRODUCT_REQUEST, GET_PRODUCTS_FAILURE, GET_PRODUCTS_REQUEST, GET_PRODUCTS_SUCCESS, GET_ALL_PRODUCTS_FAILURE, GET_ALL_PRODUCTS_REQUEST, GET_ALL_PRODUCTS_SUCCESS, CREATE_PRODUCT_REQUEST, CREATE_PRODUCT_FAILURE, UPDATE_PRODUCT_REQUEST,
  UPDATE_PRODUCT_FAILURE,
  DELETE_PRODUCT_SUCCESS,
} from "./ActionType";


export const getProducts = () => async (dispatch) => {
  dispatch({ type: GET_PRODUCTS_REQUEST })
  try {
    const { data } = await privateAxios.get(`admin/products`);
    dispatch({ type: GET_PRODUCTS_SUCCESS, payload: data })
  } catch (error) {
    dispatch({ type: GET_PRODUCTS_FAILURE, payload: error.message })
  }
}

export const getAllProductByAdmin = () => async (dispatch) => {
  dispatch({ type: GET_ALL_PRODUCTS_REQUEST });
  try {
    const { data } = await privateAxios.get(`admin/products/admin`);
    dispatch({ type: GET_ALL_PRODUCTS_SUCCESS, payload: data });
  } catch (error) {
    dispatch({ type: GET_ALL_PRODUCTS_FAILURE, payload: error.message });
  }
};

export const createProduct = (productData, handleCancle) => async (dispatch) => {
  dispatch({ type: CREATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.post(`admin/product`, productData);
    if (data.status === "SUCCESS") {
      dispatch(getAllProductByAdmin());
      dispatch(getProducts());
      toast.success(data.response);
      handleCancle();
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: CREATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const updateProduct = (productId, productData, handleCancle) => async (dispatch) => {
  dispatch({ type: UPDATE_PRODUCT_REQUEST });
  try {
    const { data } = await privateAxios.put(
      `admin/product/${productId}`,
      productData
    );
    if (data.status === "SUCCESS") {
      dispatch(getAllProductByAdmin());
      dispatch(getProducts());
      toast.success("Product Updated Successfully");
      handleCancle()
    } else {
      toast.error(data.response);
    }
  } catch (error) {
    if (error.response.data.status === "FAIL") {
      toast.error(error.response.data.response);
    }
    dispatch({ type: UPDATE_PRODUCT_FAILURE, payload: error.message });
  }
};

export const approvedProduct = (productId, payload, setConfirmOpen, setProduct) => async (dispatch) => {
  dispatch({ type: APPROVED_PRODUCT_REQUEST })
  try {
    const { data } = await privateAxios.put(`admin/product/${productId}/approved`, payload);
    if (data.status === "SUCCESS") {
      dispatch(getProducts())
      toast.success("Product Approved Successfully")
      setConfirmOpen(false)
      setProduct(null)
    } else {
      toast.error(data.response || "Failed to approving product.");
    }
  } catch (error) {
    toast.error(error.response?.data?.response || "An error occurred while approving  the product.")
    dispatch({ type: APPROVED_PRODUCT_FAILURE, payload: error.message })
  }
}

export const rejectProduct = (productId, message, setOpenDialog) => async (dispatch) => {
  dispatch({ type: REJECT_PRODUCT_REQUEST })
  try {
    const { data } = await privateAxios.put(`admin/product/${productId}/reject/message/${message}`);
    if (data.status === "SUCCESS") {
      dispatch(getProducts())
      toast.success("Product Reject Successfully")
      setOpenDialog(false)
    } else {
      toast.error(data.response || "Failed to reject product.");
    }
  } catch (error) {
    toast.error(error.response?.data?.response || "An error occurred while rejecting the product.")
    dispatch({ type: REJECT_PRODUCT_FAILURE, payload: error.message })
  }
}

export const deleteProduct = (productId, setOpenDeleteDialog) => async (dispatch) => {
  dispatch({ type: DELETE_PRODUCT_REQUEST })
  try {
    const { data } = await privateAxios.delete(`vendor/product/${productId}`);
    if (data.status === "SUCCESS") {
      dispatch({ type: DELETE_PRODUCT_SUCCESS, payload: productId })
      dispatch(getProducts())
      toast.success(data.response)
      setOpenDeleteDialog(false)
    } else {
      toast.error(data.response || "Failed to delete product.");
    }
  } catch (error) {
    toast.error(error.response?.data?.response || "An error occurred while deleting the product.")
    dispatch({ type: DELETE_PRODUCT_FAILURE, payload: error.message })
  }
}
